import React from 'react';
import styled, { useTheme } from 'styled-components';
import { Box, OSKThemeType } from 'oskcomponents';

export type AbbreviationIconProps = {
    /** Additional CSS class to add to the icon */
    className?: string;
    /** The label from which to extract an abbreviation from. The ProfileIcon
     * will automatically determine the best-fit abbreviation to use. */
    label: String;
    /** The method to invoke when the icon is pressed. */
    onClick?: () => void;
    /** How big the icon should be */
    iconSize?: number;
};

export const AbbreviationIcon = styled(({ className, label, onClick, iconSize = 20 }: AbbreviationIconProps) => {
    // Extract, at most, 2 letters from the label
    let abbreviation = '';
    const words = (label || '').split(' ');
    if (words.length > 1 && words[0].length > 0) {
        abbreviation = words[0][0].toUpperCase() + words[words.length - 1][0].toUpperCase();
    } else if (label.length > 0) {
        abbreviation = label[0].toUpperCase();
    }

    const theme = useTheme() as OSKThemeType;
    return (
        <Box className={className} onClick={onClick}>
            {abbreviation}
        </Box>
    );
})`
    & {
        padding: 18px;
        border-radius: ${(props: any) => props.iconSize ?? 20}px;
        width: ${(props: any) => props.iconSize ?? 20}px;
        height: ${(props: any) => props.iconSize ?? 20}px;
        justify-content: center;
        align-items: center;
        font-size: ${(props: any) => (props.iconSize > 20 ? '2rem' : '1rem')};
        color: ${(props: any) => props.theme.colors.primary.invertedBg};
        background-color: ${(props: any) => props.theme.colors.primary.invertedFg};
        cursor: pointer;
        text-decoration: none !important;
    }

    &:hover {
        background-color: ${(props: any) => props.theme.colors.accent};
    }
`;
